import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Toaster } from "react-hot-toast";
import { Provider } from "react-redux";
import store from "./store";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

if (typeof window !== "undefined") {
  if ("history" in window && "scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
  }
  ScrollTrigger.clearScrollMemory();
  window.scrollTo(0, 0);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <Toaster position="bottom-right" />
    <App />
  </Provider>
);
